import { Backdrop, Button, ThemeToggle } from '@memorizecards/ui';
import type { ReactNode } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { IconLogout, IconUser } from './Icons';
import { Logo } from './Logo';
import { useAuth } from '../state/auth';

const NAV = [
  { to: '/admin', rotulo: 'Visão geral', exact: true },
  { to: '/admin/usuarios', rotulo: 'Usuários' },
  { to: '/admin/uso', rotulo: 'Uso' },
  { to: '/admin/gratis', rotulo: 'Flashcards grátis' },
  { to: '/admin/pedidos', rotulo: 'Pedidos' },
  { to: '/admin/pagamentos', rotulo: 'Pagamentos' },
  { to: '/admin/cupons', rotulo: 'Cupons' },
  { to: '/admin/cadastros', rotulo: 'Cadastros (cupom 5%)' },
  { to: '/admin/feedbacks', rotulo: 'Feedbacks' },
  { to: '/admin/etl', rotulo: 'Flashcards' },
  { to: '/admin/backup', rotulo: 'Backup' },
  { to: '/admin/seguranca', rotulo: 'Segurança' },
  { to: '/admin/emails', rotulo: 'E-mails' },
  { to: '/admin/auditoria', rotulo: 'Auditoria' },
];

export function AdminShell(): ReactNode {
  const { user, sair } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen">
      <Backdrop />

      <header className="sticky top-0 z-40 border-b border-mc-line bg-mc-surface-nav backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-mc-content items-center gap-4 px-4 sm:px-6">
          <NavLink to="/admin" className="shrink-0">
            <Logo />
          </NavLink>
          <span className="hidden rounded-mc-pill border border-mc-accent/40 bg-mc-accent/10 px-3 py-1 text-xs font-medium text-mc-accent sm:inline">
            Superadmin
          </span>

          <nav className="ml-auto hidden items-center gap-1 lg:flex" aria-label="Admin">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                className={({ isActive }) =>
                  [
                    'rounded-mc-pill px-3 py-2 text-sm transition-colors',
                    isActive
                      ? 'bg-mc-accent/12 text-mc-accent ring-1 ring-mc-accent/40'
                      : 'text-mc-ink2 hover:text-mc-ink',
                  ].join(' ')
                }
              >
                {item.rotulo}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:ml-0">
            <ThemeToggle size="sm" />
            <NavLink
              to="/baralhos"
              className="hidden text-sm text-mc-ink2 underline-offset-4 hover:text-mc-accent hover:underline sm:inline"
            >
              Plataforma
            </NavLink>
            <span className="hidden items-center gap-2 text-sm text-mc-ink2 sm:inline-flex">
              <IconUser className="size-4" />
              {user?.email}
            </span>
            <Button
              variant="quiet"
              size="sm"
              onClick={() => void sair().then(() => navigate('/entrar'))}
            >
              <IconLogout className="size-4" />
            </Button>
          </div>
        </div>

        <nav
          className="flex gap-1 overflow-x-auto border-t border-mc-line px-4 py-2 lg:hidden"
          aria-label="Admin móvel"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                [
                  'shrink-0 rounded-mc-pill px-3 py-1.5 text-xs',
                  isActive ? 'bg-mc-accent/12 text-mc-accent' : 'text-mc-ink2',
                ].join(' ')
              }
            >
              {item.rotulo}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="relative z-[2] mx-auto max-w-mc-content px-4 py-8 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
